class CustomSelect extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: "open" });
    this.cellIndex = this.dataset.index;
    this.shadowRoot.innerHTML = `
      <style>
        :host {
          display: block;
        }
      </style>  
      <slot></slot>
    `;

    this._value = null;
  }

  connectedCallback() {
    this.optionSelected();
    this.addEventListener("change", (e) => {
      // console.log("选中值:", e.detail.value, "显示文本:", e.detail.text);
      const tableData = this.getTableData(e.detail.value);
      if (!tableData) return;
      this.updateData(tableData);
      this.updateProductInfo(tableData);
    });
  }

  optionSelected() {
    const header = this.querySelector(".select-header");
    const headerText = header.querySelector("span");
    const options = this.querySelectorAll(".option");

    header.addEventListener("click", () => {
      const container = this.querySelector(".options-container");
      container.style.display =
        container.style.display === "block" ? "none" : "block";
    });

    options.forEach((option) => {
      option.addEventListener("click", () => {
        this._value = option.dataset.value;
        headerText.textContent = option.textContent;
        this.querySelector(".options-container").style.display = "none";
        option.classList.add("selected");
        this.querySelectorAll(".option").forEach((el) => {
          if (el !== option) el.classList.remove("selected");
        })

        this.dispatchEvent(
          new CustomEvent("change", {
            detail: {
              value: this._value,
              text: option.textContent,
            },
          })
        );
      });
    });
  }

  getSectionRoot() {
    return this.closest(".section-compare-table");
  }

  getCompareTable() {
    return this.closest(".compare-table");
  }

  getTableData(id) {
    const section = this.getSectionRoot();
    const tableElemJSON = section?.querySelector("[data-table-json]");
    if (!tableElemJSON) {
      console.error("Missing table JSON");
      return null;
    }

    try {
      const tableJSON = JSON.parse(tableElemJSON.textContent);
      return tableJSON[id] ?? null;
    } catch (error) {
      console.error("Invalid table JSON", error);
      return null;
    }
  }

  updateData(data) {
    if (!data?.compareData) return;

    const compareTata = data.compareData;
    const table = this.getCompareTable();
    if (!table) return;

    const cellElems = table.querySelectorAll(
      `.compare-table-cell.cell-${this.cellIndex}`
    );
    cellElems.forEach((cellElem) => {
      const cellTextElem = cellElem.querySelector(".cell-text");
      if (cellTextElem) {
        const value = cellTextElem.dataset.value;
        cellTextElem.textContent = compareTata[value];
      }
    });
  }

  updateProductInfo(data) {
    if (!data?.productInfo) return;

    const productData = data.productInfo;
    const table = this.getCompareTable();
    if (!table) return;

    const cellElems = table.querySelectorAll(
      `.compare-table-cell.cell-${this.cellIndex}`
    );
    cellElems.forEach((cellElem) => {
      const productInfo = cellElem.querySelector(".product-info");
      if (productInfo) {
        const prodcutImageLink  = productInfo.querySelector(".product-image");
        const prodcutImage  = productInfo.querySelector(".product-image img");
        const productPrice = productInfo.querySelector(".product-price");
        const buyBtn = productInfo.querySelector("buy-now-button");
        const buyBtnText = buyBtn.querySelector("span");
        const productLink = productInfo.querySelector(".product-link");
        prodcutImage.src = productData.imageUrl;
        productPrice.innerHTML = productData.price;
        buyBtn.setAttribute("data-variant-id", productData.variantId);
        productLink.href = productData.url;
        prodcutImageLink.href = productData.url;
        if (productData.isStock){
          buyBtn.classList.remove("product-btn--sold-out");
          buyBtnText.textContent = "今すぐ購入";
        }else{
          buyBtn.classList.add("product-btn--sold-out");
          buyBtnText.textContent = "売り切れ";
        }
      }
    })
  }

  get value() {
    return this._value;
  }
}

if (!customElements.get("custom-select")) {
  customElements.define("custom-select", CustomSelect);
}
